import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { buildCanonical } from "../../utils/seo";

/**
 * Fallback canonical for every route: the page's own clean URL (production host,
 * no query string, no trailing slash). Pages that render their own
 * <link rel="canonical"> via Helmet (gig/job/project detail, category pages, ...)
 * override this, since Helmet keeps a single canonical tag.
 */
const DefaultCanonical = () => {
  const { pathname } = useLocation();
  return (
    <Helmet>
      <link rel="canonical" href={buildCanonical(pathname)} />
    </Helmet>
  );
};

export default DefaultCanonical;
